import { useState,useEffect } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import { TabPanel,Button,ColorIndicator,FlexItem,
 Popover,RangeControl
  } from '@wordpress/components';
import {
    __experimentalHStack as HStack,
} from '@wordpress/components';
import {
    __experimentalToolsPanel as ToolsPanel,
    __experimentalToolsPanelItem as ToolsPanelItem,
} from '@wordpress/components';
import VayuBlocksGradients from './gradients';
import VayuBlocksColors from './color';
import VayuBlocksImage from './image';

/**
 * ColorPanel Component
 * 
 * The `ColorPanel` component provides a user interface for managing color and gradient settings in the WordPress block editor. 
 * It allows users to select and apply colors or gradients to various block attributes. The panel supports both color and gradient selection,
 * and provides options for customizing the appearance of blocks.
 * 
 * <VayuBlocksBackground
                     setAttributes={setAttributes}
                     colorPanel = {[
                         {
                             active: ['color'],
                             label: 'Icon Color',
                             key:'color',
                             value:attributes.color
 
                         },
                         {
                             active: ['color'],
                             label: 'Hover',
                             key:'hoverColor',
                             value:attributes.hoverColor
                         },
                         ,
                         {
                             active: ['media'],
                             label: 'Upload Image',
                             key:'backgroundImage',
                             value:attributes.backgroundImage
                         }
                     ]}
                 />
*/
export const VayuBlocksBackground = (props) =>{
  const {onChange} = props;

    const [ popoverAnchor, setPopoverAnchor ] = useState();
    const [ colorAttribute, setColorAttribute] = useState({});
    const [ activeTab, setActiveTab ] = useState('color');
    const [ isVisible, setIsVisible ] = useState( false );
    const [opacity, setopacity] = useState(colorAttribute.opacity);
    const [showopacity, setshowopacity] = useState(false);
    const [mediaac, setmediaac] = useState(false);

    const [ colorTabActive, setcolorTabActive ] = useState( [
      {
        name: 'color',
        title: 'Color',
      }
    ] );

/**
 * Checks the type of the provided string and updates the active tab accordingly.
 * 
 * @param {string} str - The input string to determine its type.
 * @param {string} tab - The current tab name.
 */
const isActiveTabCheck = (str, tab) => {
  // Check if the string is a valid HEX color (e.g., #FFF, #FFFFFF)
  const isHexColor = /^#([0-9A-F]{3}){1,2}$/i.test(str);

  // Check if the string contains a linear gradient (e.g., linear-gradient(to right, red, blue))
  const isLinearGradient = /^linear-gradient/i.test(str);

  // Check if the string contains a radial gradient (e.g., radial-gradient(circle, red, blue))
  const isRadialGradient = /^radial-gradient/i.test(str);

  // If the string is a gradient (either linear or radial), set the active tab to 'gradient'
  if (isLinearGradient || isRadialGradient) {
      setActiveTab('gradient');
  } 
  // If the string is a hex color or the previous tab was 'gradient', set it to 'color'
  else if (isHexColor || tab === 'gradient') {
      setActiveTab('color');
  } 
  // Otherwise, set the active tab to the provided tab name
  else {
      setActiveTab(tab);
  }
};

    // tabs add
    const handleActiveColorTab = (activeColorTab)=>{
            let colortab =   {
            name: 'color',
            title: 'Color',
    
            }
            let gradientTab =   {
            name: 'gradient',
            title: 'Gradient',
            }

            let ImageTab =   {
              name: 'media',
              title: 'Media',
              }


        if(activeColorTab.includes('gradient')){
        setcolorTabActive( [colortab,gradientTab] );
        }else if(activeColorTab.includes('color')){
        setcolorTabActive ([colortab])
        }else{
        setcolorTabActive ([ImageTab])
        }
    }


    const opacityValue = () => {
      const isOpacityEnabled = colorAttribute.showopacity ?? false; // Default to false
      setshowopacity(isOpacityEnabled);
      
      if (isOpacityEnabled) {
          setopacity(colorAttribute.opacity ?? null);
      }
  };

    const toggleVisible =  (data) => {
                setmediaac(false);
              setColorAttribute(data);
              setIsVisible(true);
              handleActiveColorTab(data.active);
              isActiveTabCheck(data.value,data.active[0]);
              opacityValue();

    }


      // Render the appropriate component based on tabName
    const panelColors = (tabName) => {
      switch (tabName.name) {
          case 'gradient':
              return <VayuBlocksGradients {...props} attributeKey={colorAttribute.key} />;
  
          case 'color':
              return <VayuBlocksColors {...props} attributeKey={colorAttribute.key} />;

                
          case 'media':
            return <VayuBlocksImage {...props} attributeKey={colorAttribute.key} />;
      }
  }

    const onFocusOutsideClick = (event) =>{
         setIsVisible(false);
     }

    const colorButton = (props) => {
    let colorData = props.colorPanel;

    // reste data
    const isReset = (key)=>{
      onChange(key,'');
    }
  
  
    const defaultLayout = (colorData) => {
      return(colorData && colorData.map((data, i) => (
        <ToolsPanelItem
            key={i}
            hasValue={() => !!data?.value}
            label={__(data.label, 'vayu_blocks')}
            onDeselect={() => isReset(data.key)}
            isShownByDefault
        >
           { data.active[0] !=='media' && <Button
                ref={setPopoverAnchor}
                onClick={() => toggleVisible(data)}
                className={`block-editor-panel-color-gradient-settings__dropdown ${colorAttribute.key === data.key && 'is-open'}`}
            >
                <HStack alignment="left">
                    <ColorIndicator
                        className="block-editor-panel-color-gradient-settings__color-indicator"
                        colorValue={data?.value}
                    />
                    
                    <FlexItem>{data.label}</FlexItem>
                </HStack>
            </Button>}
        
            {  data.active[0] ==='media' && 
            <div  onClick={() => setmediaac(true)}>
         
                    
                    <FlexItem><VayuBlocksImage {...props} tabname = {mediaac} attributeKey={data.key} />
                    </FlexItem>
         
            </div>
            }
          
       </ToolsPanelItem>
))
      );
    }

    return (
        <div className="vayu_blocks_colorpanel">
            <ToolsPanel label={__(props.headingLabel ? props.headingLabel : 'Color')}  >

              {defaultLayout(colorData)}
               
            </ToolsPanel>
            {isVisible && (
                <Popover
                    placement="left-start"
                    onFocusOutside={onFocusOutsideClick}
                    anchor={popoverAnchor}
                    onClose={() => setIsVisible(false)}
                    offset={35}
                >
                    <fieldset>
                        <TabPanel
                            className="ubp-tab-panel"
                            activeClass="is-active"
                           initialTabName={ activeTab }
                            tabs={colorTabActive}
                          //  onSelect={(tabName) => console.log(tabName)}
                        >
                            {tab => <div className={`vb-color-component ${tab?.name === 'color' ? 'vb-extra-margin-color' : ''}`}>

                              {panelColors(tab)}  

                                  {colorAttribute.showopacity && (
                                  <>
 
                                  <RangeControl
                                      label={`Opacity`}
                                      max={1}
                                      min={0}
                                      step={0.1}
                                      value={colorAttribute.opacity}
                                      onChange={(value) => {
                                        onChange(colorAttribute.opacitykey,value); // Dynamically update the correct key
                                        // setAttributes({
                                        //     [colorAttribute.opacitykey]: value, // Dynamically update the correct key
                                        // });
                                        setColorAttribute({
                                          ...colorAttribute,
                                          opacity: value, // Ensure local state updates
                                      });
                                    }}
                                    
                                  />   
                                 </>
                                )}

                              </div>}
                        </TabPanel>
                    </fieldset>
                </Popover>
            )}
        </div>
    );
};

return colorButton(props);
};